module.exports = __webpack_public_path__ + "static/media/microverse-xo.c3945c9f.png";